import { useCustomQueryWithParams } from 'shared/hooks/useCustomQueryWithParams'
import { currenciesApi } from '../../../api'
import { GET_FIAT_CURRENCIES } from '../../../api/constants'

export const useFiatCurrencies = () => {
  const { data } = useCustomQueryWithParams([GET_FIAT_CURRENCIES], () => currenciesApi.getFiatCurrencies())
  const currencies = data?.data ?? []

  return currencies
}
